











































































import {
  createComponent,
  provide,
  inject,
  onMounted,
  computed,
  reactive,
  ref,
  SetupContext
} from "@vue/composition-api";

import DisplayUIKey from "@/components/display-ui-key";
import MemberKey from "@/components/member-key";

import ConfirmDialog from "@/components/templates/Common/ConfirmDialog.vue";
import logoSvg from "@/assets/svg/logo.svg";

export default createComponent({
  setup(props: {}, context: any) {
    // context.refsでエラーになるのでcontextはany
    const displayuiStore = inject(DisplayUIKey);
    if (!displayuiStore) {
      throw new Error(`${DisplayUIKey} is not provided`);
    }
    const form = ref<null | { validate: () => null }>(null);

    const memberStore = inject(MemberKey);
    if (!memberStore) {
      throw new Error(`${MemberKey} is not provided`);
    }

    const state = reactive({
      isValid: false
    });

    const globalStore = context.root.$store;

    const response = computed(() => memberStore.response);

    const loading = computed(() => memberStore.loading);

    const cardNumberLength = 16;
    const cardNumber = ref<string>("");
    const inputDisplayFlag = ref<boolean>(true);
    const cardNumberRules = [
      (value: string) => !!value || "入力必須項目です",
      (value: string) => /^[0-9]*$/.test(value) || "半角数字で入力して下さい。",
      (value: string) => {
        if (value.toString().length == cardNumberLength) return true;
        return "16桁のカード番号を入力して下さい。";
      }
    ];

    const openConfirmDialog = () => {
      if (form.value!.validate()) {
        // 仮アカウントの場合、パスワードリセットさせない
        if (cardNumber.value.match(/^9[0-9]{15}$/)) {
          displayuiStore.showErrorSnackBar(
            "仮ログインIDではパスワード変更はできません。本登録を完了してください。"
          );
          return;
        }

        if (cardNumber.value.length == cardNumberLength) {
          displayuiStore.openConfirmDialog();
        }
      }
    };

    const executeSubmit = async () => {
      await memberStore.resetPassword(cardNumber.value);
      if (response.value.status < 400) {
        displayuiStore.showSuccessSnackBar(
          "「パスワード変更手続きのお知らせ」を送信しました。"
        );
      }
      if (response.value.status >= 400) {
        displayuiStore.showErrorSnackBar(
          "「パスワード変更手続きのお知らせ」の送信に失敗しました。"
        );
      }
      displayuiStore.closeConfirmDialog();
      memberStore.clearResponse();
    };

    onMounted(async () => {
      displayuiStore.closeConfirmDialog();
    });

    return {
      state,
      form,
      cardNumberLength,
      cardNumber,
      executeSubmit,
      inputDisplayFlag,
      openConfirmDialog,
      cardNumberRules
    };
  },
  components: {
    logoSvg,
    ConfirmDialog
  }
});
